import * as PropertyBucket from '../../Properties/Properties.js';

/* Supports save and update operations */
export function getServicePromise(url, method, body, rawError) {
  return new Promise(function (resolve, reject) {
    fetch(url, {
      method: method,
      body: JSON.stringify(body),
      headers: new Headers({
        "content-type": "application/json",
        Accept: "application/json, application/xml, text/plain, text/html, */*",
        Authorization: "Bearer " + localStorage.getItem("token"),
      }),
    })
      .then((response) => {
        if (!response.ok) {
          if (rawError) {
            reject(response);
          } else {
            let errorMessage = errorMessageText(response.status);
            reject(errorMessage);
          }
          return;
        }

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          return response.json();
        } else {
          return null;
        }
      })
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(
          error.message === "Failed to fetch"
            ? "Serwer jest niedostępny"
            : error.message
        );
      });
  });
}


/* Supports get operations */
export function getService(url, method, returnAsJSON = true) {
  return fetch(url, {
    method: method,
    headers: new Headers({
      "content-type": "application/json",
      Accept: "application/json, application/xml, text/plain, text/html, */*",
      Authorization: "Bearer " + localStorage.getItem("token"),
    }),
  }).then((response) => {
    if (!response.ok) {
      let errorMessage = errorMessageText(response.status);
      throw Error(errorMessage);
    } else {
      if (method !== "DELETE") {
        return returnAsJSON ? response.json() : response;
      }
    }
  });
}

/* Get service with support errors */
export function getServiceWithSupportErrors(url, method, body) {
  return new Promise(function (resolve, reject) {
    fetch(url, {
      method: method,
      body: JSON.stringify(body),
      headers: new Headers({
        "content-type": "application/json",
        Accept: "application/json, application/xml, text/plain, text/html, */*",
        Authorization: "Bearer " + localStorage.getItem("token"),
      }),
    })
      .then((response) => {
        if (response.ok || response.status === 400) {
          resolve(response.json());
        } else {
          const errorMessage = errorMessageText(response.status);
          reject(errorMessage);
        }
      })
      .catch((error) => {
        reject(
          error.message === "Failed to fetch"
            ? "Serwer jest niedostępny"
            : error.message
        );
      });
  });
}

export function errorMessageText(statusHttp) {
  let errorMessage;
  switch (statusHttp) {
    case 400:
      errorMessage = "Błędne zapytanie.";
      break;
    case 401:
      errorMessage =
        "Nieautoryzowany dostęp. Żądanie zasobu, który wymaga uwierzytelnienia";
      break;
    case 404:
      errorMessage =
        "Nie znaleziono. Serwer nie odnalazł zasobu według podanego URL.";
      break;
    case 500:
      errorMessage = "Wystąpił błąd serwera";
      break;
    case 422:
      errorMessage = PropertyBucket.getCannotEditControlMessage();
      break;
    default:
      errorMessage = "Wystąpił nieoczekiwany błąd";
  }
  return errorMessage;
}
